/* ============================================================
   ONE Coffee — filtrare de colectie si selectie de gramaj.

   Filtrele nu mai sunt scrise in cod. Fiecare casuta poarta
   data-facet (numele grupului) si value (handle-ul metaobiectului),
   iar cardurile poarta data-<grup> cu handle-urile lor. Un grup nou
   adaugat in taxonomie functioneaza fara nicio modificare aici.
   ============================================================ */
(function () {
  'use strict';

  function init(root) {
    if (!root || root.dataset.oneInit === '1') return;
    root.dataset.oneInit = '1';

    var grid = root.querySelector('[data-one-grid]');
    if (!grid) return;

    var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-one-card]'));
    var titluri = Array.prototype.slice.call(grid.querySelectorAll('[data-one-group]'));
    var inputs = Array.prototype.slice.call(root.querySelectorAll('[data-facet]'));
    var segments = Array.prototype.slice.call(root.querySelectorAll('[data-segment]'));
    var countEl = root.querySelector('[data-one-count]');
    var emptyEl = root.querySelector('[data-one-empty]');
    var activeBox = root.querySelector('[data-one-active]');
    var activeText = root.querySelector('[data-one-active-text]');
    var resetBtn = root.querySelector('[data-one-reset]');

    var forcedSegment = null;
    var lots = Array.prototype.slice.call(root.querySelectorAll('[data-one-lot]'));
    var forcedLot = null;
    /* Butoanele de deasupra grilei nu mai filtreaza toate dupa acelasi camp.
       „Cafea de origine" si „Blenduri" impart tot raftul si citesc data-lot;
       „Decaf" si „Low caf" sunt felii din el si citesc data-cofeina. Campul
       vine din butonul apasat (data-one-lot-camp), deci un buton nou pe alt
       camp nu cere cod nou aici. Lipsa atributului inseamna data-lot, ca
       butoanele vechi sa mearga neschimbate. */
    var forcedLotCamp = null;
    var contoare = [];

    function campulLui(btn) {
      return btn.dataset.oneLotCamp || 'lot';
    }

    function tokens(card, facet) {
      var raw = card.dataset[facet] || '';
      return raw.split(',').map(function (s) { return s.trim(); }).filter(Boolean);
    }

    function selected() {
      var groups = {};
      inputs.forEach(function (input) {
        if (!input.checked) return;
        var facet = input.dataset.facet;
        (groups[facet] = groups[facet] || []).push(input.value);
      });
      return groups;
    }

    function labels() {
      return inputs
        .filter(function (i) { return i.checked; })
        .map(function (i) { return i.dataset.label || i.value; });
    }

    function apply() {
      var groups = selected();
      var facets = Object.keys(groups);
      var shown = 0;

      cards.forEach(function (card) {
        var visible = true;

        if (forcedSegment && forcedSegment !== 'all') {
          if ((card.dataset.usage || '') !== forcedSegment) visible = false;
        }

        /* Un card poate avea mai multe valori pe acelasi camp, separate prin
           virgula, deci comparam pe lista, nu pe sir intreg. */
        if (forcedLot) {
          var camp = forcedLotCamp || 'lot';
          if (tokens(card, camp).indexOf(forcedLot) === -1) visible = false;
        }

        for (var i = 0; i < facets.length && visible; i++) {
          var facet = facets[i];
          var wanted = groups[facet];
          var has = tokens(card, facet);
          var match = wanted.some(function (w) { return has.indexOf(w) > -1; });
          if (!match) visible = false;
        }

        card.hidden = !visible;
        if (visible) shown++;
      });

      /* Titlul unui grup („Echipamente", „Consumabile si accesorii") dispare
         cand filtrele ii golesc randul. Cardurile unui grup sunt fratii care
         urmeaza titlul pana la urmatorul titlu, deci nu e nevoie de niciun
         atribut nou in card. */
      titluri.forEach(function (titlu) {
        var el = titlu.nextElementSibling;
        var areCeva = false;
        while (el && !el.hasAttribute('data-one-group')) {
          if (el.hasAttribute('data-one-card') && !el.hidden) { areCeva = true; break; }
          el = el.nextElementSibling;
        }
        titlu.hidden = !areCeva;
      });

      contoare.forEach(function (fn) { fn(); });

      /* Poza pe numar de grupuri: cand e bifat un singur numar, cardurile care
         au poza lui (data-img-g2, data-img-g3) o arata; altfel revin la poza
         lor. */
      var gr = groups.grupuri && groups.grupuri.length === 1 ? groups.grupuri[0] : null;
      cards.forEach(function (card) {
        var img = card.querySelector('.one-card__media img');
        if (!img) return;
        var alt = gr ? card.getAttribute('data-img-g' + gr) : null;
        if (alt) {
          if (!img.dataset.origSrc) {
            img.dataset.origSrc = img.getAttribute('src');
            img.dataset.origSrcset = img.getAttribute('srcset') || '';
          }
          img.removeAttribute('srcset');
          img.setAttribute('src', alt);
        } else if (img.dataset.origSrc) {
          img.setAttribute('src', img.dataset.origSrc);
          if (img.dataset.origSrcset) img.setAttribute('srcset', img.dataset.origSrcset);
          delete img.dataset.origSrc;
          delete img.dataset.origSrcset;
        }
      });

      if (countEl) countEl.textContent = shown === 1 ? '1 produs' : shown + ' produse';
      if (emptyEl) emptyEl.hidden = shown !== 0;

      var active = labels();
      if (activeBox) {
        if (active.length) {
          activeBox.hidden = false;
          if (activeText) activeText.textContent = 'Filtrat dupa: ' + active.join(', ');
        } else {
          activeBox.hidden = true;
        }
      }
    }

    inputs.forEach(function (input) { input.addEventListener('change', apply); });

    segments.forEach(function (btn) {
      btn.addEventListener('click', function () {
        segments.forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
        btn.setAttribute('aria-pressed', 'true');
        forcedSegment = btn.dataset.segment;
        apply();
      });
    });

    /* Selectorul de lot: un clic arata doar grupul ales, al doilea clic pe
       acelasi buton arata iar tot. Butoanele sunt exclusive intre ele, si
       cele doua care impart raftul, si cele doua de cofeina: apasarea unuia
       il stinge pe cel dinainte, ca sa se vada mereu exact ce scrie pe
       butonul aprins. Alegerea se pastreaza in adresa (?lot=), ca linkul
       copiat sa deschida pagina la fel. */
    function setLot(value, camp) {
      forcedLot = value || null;
      forcedLotCamp = forcedLot ? (camp || 'lot') : null;
      lots.forEach(function (b) {
        var activ = forcedLot && b.dataset.oneLot === forcedLot && campulLui(b) === forcedLotCamp;
        b.setAttribute('aria-pressed', activ ? 'true' : 'false');
      });
      if (window.history && window.history.replaceState) {
        var u = new URL(window.location.href);
        if (forcedLot) u.searchParams.set('lot', forcedLot); else u.searchParams.delete('lot');
        window.history.replaceState(null, '', u.pathname + u.search + u.hash);
      }
    }

    lots.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var acelasi = forcedLot === btn.dataset.oneLot && forcedLotCamp === campulLui(btn);
        if (acelasi) {
          setLot(null);
        } else {
          setLot(btn.dataset.oneLot, campulLui(btn));
        }
        apply();
      });
    });

    if (resetBtn) {
      resetBtn.addEventListener('click', function (event) {
        event.preventDefault();
        inputs.forEach(function (i) { i.checked = false; });
        setLot(null);
        apply();
      });
    }

    /* Preselectie din URL: ?metoda=filtru&gust=fructat
       Acceptam si formatul Shopify filter.p.m.taxonomie.<grup>=<handle>. */
    var params = new URLSearchParams(window.location.search);
    params.forEach(function (value, key) {
      var facet = key;
      var prefix = 'filter.p.m.taxonomie.';
      if (key.indexOf(prefix) === 0) facet = key.slice(prefix.length);
      value.split(',').forEach(function (v) {
        var match = inputs.filter(function (i) {
          return i.dataset.facet === facet && i.value === v.trim();
        })[0];
        if (match) match.checked = true;
      });
    });

    /* Filtrele ca acordeon. Titlul fiecarui grup devine buton; bifele nu se
       schimba, doar se ascund, deci filtrarea merge exact ca inainte.
       Pe desktop pornesc deschise Disponibilitate si Metoda, pe telefon
       toate inchise. Un grup cu o bifa activa (si din link) sta deschis, iar
       titlul arata cate bife are active, ca nimic sa nu filtreze nevazut. */
    var facetsBox = root.querySelector('.one-facets');
    if (facetsBox && !facetsBox.classList.contains('one-facets--acordeon')) {
      var mobil = window.matchMedia && window.matchMedia('(max-width: 899px)').matches;
      facetsBox.classList.add('one-facets--acordeon');
      var setari = [];
      Array.prototype.forEach.call(facetsBox.querySelectorAll('.one-facet'), function (fs, idx) {
        var legend = fs.querySelector('.one-facet__title');
        var list = fs.querySelector('.one-facet__list');
        if (!legend || !list) return;

        var grupuri = Array.prototype.map.call(fs.querySelectorAll('[data-facet]'), function (x) { return x.dataset.facet; });
        var deschis = !mobil && grupuri.some(function (g) { return g === 'regim' || g === 'promotie' || g === 'metoda'; });
        if (fs.querySelector('[data-facet]:checked')) deschis = true;

        if (!list.id) list.id = 'one-facet-' + idx + '-' + Math.random().toString(36).slice(2, 7);
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'one-facet__toggle';
        btn.setAttribute('aria-controls', list.id);
        var eticheta = document.createElement('span');
        eticheta.textContent = legend.textContent.trim();
        var nr = document.createElement('span');
        nr.className = 'one-facet__count';
        btn.appendChild(eticheta);
        btn.appendChild(nr);
        btn.insertAdjacentHTML('beforeend', '<svg class="one-facet__chev" viewBox="0 0 10 10" aria-hidden="true"><path d="M1.5 3.5 5 7l3.5-3.5" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>');
        legend.textContent = '';
        legend.appendChild(btn);

        function seteaza(open) {
          fs.classList.toggle('is-closed', !open);
          btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        }
        seteaza(deschis);
        setari.push({ fn: seteaza, open: deschis });
        btn.addEventListener('click', function () { seteaza(fs.classList.contains('is-closed')); });

        contoare.push(function () {
          var n = fs.querySelectorAll('[data-facet]:checked').length;
          nr.textContent = n ? '(' + n + ')' : '';
        });
      });
      /* Colectiile fara Disponibilitate sau Metoda (echipamente, ceai):
         pe desktop macar primul grup porneste deschis. */
      if (!mobil && setari.length && !setari.some(function (s) { return s.open; })) setari[0].fn(true);
    }

    var lotParam = params.get('lot');
    var btnParam = lots.filter(function (b) { return b.dataset.oneLot === lotParam; })[0];
    if (lotParam && btnParam) {
      forcedLot = lotParam;
      forcedLotCamp = campulLui(btnParam);
      lots.forEach(function (b) {
        b.setAttribute('aria-pressed', b === btnParam ? 'true' : 'false');
      });
    }

    apply();
  }

  function initSizes(scope) {
    scope.addEventListener('click', function (event) {
      var btn = event.target.closest ? event.target.closest('[data-one-size]') : null;
      if (!btn) return;
      var card = btn.closest('[data-one-card]');
      if (!card) return;

      card.querySelectorAll('[data-one-size]').forEach(function (b) {
        b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
      });

      var input = card.querySelector('[data-one-variant-input]');
      if (input) input.value = btn.dataset.variant;

      /* cafeaua cu macinare aleasa pe pagina: linkul duce la gramajul ales */
      var choose = card.querySelector('[data-one-choose]');
      if (choose) {
        var url = new URL(choose.getAttribute('href'), window.location.origin);
        url.searchParams.set('variant', btn.dataset.variant);
        choose.setAttribute('href', url.pathname + url.search);
      }

      var price = card.querySelector('[data-one-price]');
      if (price && btn.dataset.price) {
        price.innerHTML = (btn.dataset.cmp ? '<s class="one-card__was">' + btn.dataset.cmp + '</s>' : '') + btn.dataset.price;
        price.classList.toggle('one-card__price--promo', !!btn.dataset.cmp);
      }
      var badge = card.querySelector('.one-card__promo');
      if (badge) {
        if (btn.dataset.pct) { badge.textContent = '−' + btn.dataset.pct + '%'; badge.style.display = ''; }
        else { badge.style.display = 'none'; }
      }
    });
  }

  function boot() {
    document.querySelectorAll('[data-one-collection]').forEach(init);
    initSizes(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('[data-one-collection]').forEach(init);
  });
})();